import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import * as translation_en from "./locale/en_US.json";

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: {
            en_US: {
                translation: translation_en,
            },
        },
        returnEmptyString: false,
        detection: {
            order: ["querystring", "cookie"],
            lookupQuerystring: "lang",
            lookupCookie: "amc_lang",
        },
        nsSeparator: false,
        keySeparator: false,
    });
